var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cms-block',_vm._b({on:{"block-selected":_vm.selectBlock}},'cms-block',_vm.$props,false),_vm._l((_vm.block.children),function(child){return _c('cms-block-renderer',{key:child.id,attrs:{"block":child,"block-selection":_vm.blockSelection,"parent":_vm.block,"editable":_vm.editable},on:{"block-selected":_vm.selectBlock}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }